import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2Icon } from 'lucide-react';
export function TireSalesPage() {
  return <div data-id="element-1258">
      {/* Page Header */}
      <div className="bg-[#000000] py-14 px-4 sm:px-6 lg:px-8 text-center" data-id="element-1259">
        <p className="text-[#CC0000] font-bold text-sm uppercase tracking-widest mb-3" data-id="element-1260">
          Our Services
        </p>
        <h1 className="text-4xl sm:text-5xl font-black text-white" data-id="element-1261">
          🛞 Tire Sales
        </h1>
        <p className="text-gray-400 text-base mt-4 max-w-xl mx-auto" data-id="element-1262">
          Top global brands for every vehicle — cars, SUVs, trucks, and more.
        </p>
      </div>

      {/* Main Content */}
      <section className="w-full bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-1263">
        <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-1264">
          <div data-id="element-1265">
            <h2 className="text-2xl sm:text-3xl font-black text-black mb-5" data-id="element-1266">
              The Right Tire for Every Road
            </h2>
            <p className="text-gray-600 leading-relaxed mb-5" data-id="element-1267">
              At Ameritech Tires, we carry an extensive inventory of tires from
              the world's most trusted brands — Michelin, Goodyear, Bridgestone,
              Continental, Pirelli, and more. Whether you're looking for
              all-season reliability, high-performance grip, or winter-ready
              traction, we have the perfect tire for your vehicle and budget.
            </p>
            <p className="text-gray-600 leading-relaxed" data-id="element-1268">
              Our knowledgeable staff will walk you through your options,
              explain the differences, and help you make a confident, informed
              decision. No pressure, no upsells — just honest advice from people
              who know tires.
            </p>
          </div>

          {/* What's Included */}
          <div className="bg-[#F5F5F5] rounded-lg p-8" data-id="element-1269">
            <h3 className="font-black text-black text-xl mb-6" data-id="element-1270">
              What's Included
            </h3>
            <ul className="space-y-4" data-id="element-1271">
              <li className="flex items-start gap-3" data-id="element-1272">
                <CheckCircle2Icon size={20} className="text-[#CC0000] flex-shrink-0 mt-0.5" data-id="element-1273" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1274">
                  Wide selection of all-season, performance, and winter tires
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1275">
                <CheckCircle2Icon size={20} className="text-[#CC0000] flex-shrink-0 mt-0.5" data-id="element-1276" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1277">
                  Tires for cars, SUVs, trucks, vans, and commercial vehicles
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1278">
                <CheckCircle2Icon size={20} className="text-[#CC0000] flex-shrink-0 mt-0.5" data-id="element-1279" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1280">
                  Top brands: Michelin, Goodyear, Bridgestone, Continental &amp;
                  more
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1281">
                <CheckCircle2Icon size={20} className="text-[#CC0000] flex-shrink-0 mt-0.5" data-id="element-1282" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1283">
                  Budget-friendly options without sacrificing safety
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1284">
                <CheckCircle2Icon size={20} className="text-[#CC0000] flex-shrink-0 mt-0.5" data-id="element-1285" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1286">
                  Free expert consultation to find the right fit
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-1287">
                <CheckCircle2Icon size={20} className="text-[#CC0000] flex-shrink-0 mt-0.5" data-id="element-1288" />
                <span className="text-gray-700 text-sm leading-relaxed" data-id="element-1289">
                  Free tire rotation for life with every tire purchase
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Why It Matters */}
      <section className="w-full bg-[#F5F5F5] py-16 px-4 sm:px-6 lg:px-8" data-id="element-1290">
        <div className="max-w-5xl mx-auto" data-id="element-1291">
          <h2 className="text-2xl sm:text-3xl font-black text-black mb-6 text-center" data-id="element-1292">
            Why Choosing the Right Tire Matters
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1293">
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1294">
              <div className="text-3xl mb-3" data-id="element-1295">🛡️</div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1296">
                Safety First
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1297">
                The right tire dramatically improves braking distance, cornering
                stability, and wet-weather grip.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1298">
              <div className="text-3xl mb-3" data-id="element-1299">⛽</div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1300">
                Fuel Efficiency
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1301">
                Low rolling resistance tires can improve your gas mileage by up
                to 4%, saving you money every mile.
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-[0_2px_12px_rgba(0,0,0,0.08)] p-6" data-id="element-1302">
              <div className="text-3xl mb-3" data-id="element-1303">💰</div>
              <h3 className="font-black text-black text-base mb-2" data-id="element-1304">
                Long-Term Value
              </h3>
              <p className="text-gray-500 text-sm leading-relaxed" data-id="element-1305">
                Quality tires last longer, wear more evenly, and protect your
                wheels and suspension from damage.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Strip */}
      <section className="w-full bg-[#000000] py-14 px-4 sm:px-6 lg:px-8 text-center" data-id="element-1306">
        <h2 className="text-2xl sm:text-3xl font-black text-white mb-3" data-id="element-1307">
          Ready to Find Your Perfect Tires?
        </h2>
        <p className="text-gray-400 text-base mb-8 max-w-lg mx-auto" data-id="element-1308">
          Visit any of our 3 DMV locations or book an appointment online today.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1309">
          <Link to="/contact" className="inline-flex items-center justify-center bg-[#CC0000] hover:bg-[#AA0000] text-white font-bold text-base px-8 py-4 rounded transition-colors duration-200" data-id="element-1310">
            Book an Appointment
          </Link>
          <Link to="/services" className="inline-flex items-center justify-center border-2 border-white text-white hover:bg-white hover:text-black font-bold text-base px-8 py-4 rounded transition-colors duration-200" data-id="element-1311">
            View All Services
          </Link>
        </div>
      </section>
    </div>;
}